import React from 'react';
import PropTypes from 'prop-types';
import { useTheme } from '../theme';

export function SvgInfo(props) {
  const { width, height, stroke } = props;
  const theme = useTheme();

  return (
    <svg width={width || '16px'} height={height || '16px'} viewBox="0 0 16 16" version="1.1">
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g
          transform="translate(-652.000000, -766.000000)"
          stroke={stroke ?? theme.colors.primary}
          strokeWidth="2"
        >
          <g transform="translate(564.000000, 763.000000)">
            <g transform="translate(89.333333, 4.333333)">
              <path d="M6.66666667,13.3333333 C10.348565,13.3333333 13.3333333,10.348565 13.3333333,6.66666667 C13.3333333,2.98476833 10.348565,2.04281037e-14 6.66666667,2.04281037e-14 C2.98476833,2.04281037e-14 7.72715225e-14,2.98476833 7.72715225e-14,6.66666667 C7.72715225e-14,10.348565 2.98476833,13.3333333 6.66666667,13.3333333 Z M6.66666667,5.33333333 L6.66666667,3.33333333 M6.66666667,10.3333333 L6.66666667,6.33333333" />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}

SvgInfo.propTypes = {
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
